import { ReactNode, useEffect, useMemo } from 'react';
import React from 'react';

import { Form } from '../components';
import { getLetterFields } from '../config';
import { useLetterForm } from '../hooks';
import { LetterFormData } from '../hooks/useLetterForm';
import { LetterTypes, Sources } from '../types';

export interface LetterFormProps {
  letterType: LetterTypes;
  source: Sources;
  onSuccess: (formData: LetterFormData) => void;
  children?: ReactNode;
  isDisabled: boolean;
}

const LetterForm = ({
  source,
  onSuccess,
  letterType,
  children,
  isDisabled,
}: LetterFormProps) => {
  const fields = useMemo(
    () => getLetterFields(letterType, source),
    [source, letterType],
  );
  const { control, handleSubmit, reset, isValid } = useLetterForm(fields);

  useEffect(() => {
    reset();
  }, [fields, source, letterType, reset]);

  return (
    <Form
      isDisabled={isDisabled}
      isValid={isValid}
      children={children}
      onSubmit={handleSubmit(onSuccess)}
      control={control}
      fields={fields}
    />
  );
};

export default LetterForm;
